import React from 'react'

export const ExternalLinkIcon: React.FC<{ color?: string }> = ({ color = '#5F6D7E' }) => (
  <svg
    className={`w-2.5 h-2.5 sm:w-3 sm:h-3 text-[${color}] flex-shrink-0`}
    fill='none'
    viewBox='0 0 24 24'
    stroke='currentColor'
  >
    <path
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={2.5}
      d='M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14'
    />
  </svg>
)
